import React from 'react';
import PropTypes from 'prop-types';
import { Pagination, PaginationItem, PaginationLink } from 'reactstrap';
import classnames from 'classnames';
import range from 'lodash/range';

import useStyles from './styles';


const PaginationBar = ({ pages, active, setPage }) => {
  const classes = useStyles();
  const rangeStart = Math.max(1, Math.min(pages - 6, active - 3));
  const rangeEnd = Math.min(pages, rangeStart + 6);
  const visiblePages = range(rangeStart, rangeEnd + 1);
  return (
    <Pagination className={classes.paginationBar} aria-label="Page navigation">
      {visiblePages.map((n, i) => {
        const isFirst = i === 0 && n > 1;
        const isPrevious = i === 1 && n > 2;
        const isNext = i === visiblePages.length - 2 && n < pages - 1;
        const isLast = i === visiblePages.length - 1 && n < pages;
        return (
          <PaginationItem
            key={n}
            className={classnames(classes.paginationItem, { [classes.active]: active === n })}
            active={active === n}
          >
            <PaginationLink
              first={isFirst}
              previous={isPrevious}
              next={isNext}
              last={isLast}
              className={classes.paginationLink}
              onClick={() => {
                if (isFirst) return setPage(1);
                if (isPrevious) return setPage((p) => p - 1);
                if (isNext) return setPage((p) => p + 1);
                if (isLast) return setPage(pages);
                setPage(n);
              }}
            >
              {isFirst || isPrevious || isNext || isLast ? null : n}
            </PaginationLink>
          </PaginationItem>
        )
      })}
    </Pagination>
  );
};

PaginationBar.propTypes = {
  pages: PropTypes.number.isRequired,
  active: PropTypes.number.isRequired,
  setPage: PropTypes.func.isRequired,
};

export default PaginationBar;
